/**
 * Analytics event name constants.
 * Import from here — never use raw strings in call sites.
 */

export const EVT_LOGIN = 'login';
export const EVT_REGISTER = 'register';
export const EVT_LOGOUT = 'logout';
export const EVT_LIBRARY_VIEW = 'library_view';
export const EVT_LIBRARY_SEARCH = 'library_search';
export const EVT_BOOKING_CREATE = 'booking_create';
export const EVT_BOOKING_CANCEL = 'booking_cancel';
export const EVT_SUBSCRIPTION_PURCHASE = 'subscription_purchase';
export const EVT_WALLET_TOPUP = 'wallet_topup';
export const EVT_RATING_SUBMIT = 'rating_submit';
export const EVT_INSTITUTE_LEAD_SUBMIT = 'institute_lead_submit';
export const EVT_LIBRARY_LEAD_VIEW = 'marketing_library_lead_page_view';
export const EVT_LIBRARY_LEAD_SUBMIT = 'marketing_library_lead_submit';
export const EVT_INSTITUTE_MARKETING_VIEW = 'marketing_institute_page_view';
export const EVT_INSTITUTE_MARKETING_SUBMIT = 'marketing_institute_signup_submit';
